<label class="tgl">
  <input type="checkbox" (change)="toggled.emit()" />
  <span class="tgl-btn"></span>
</label>
